import {
    AuthActionType,
    ChangeLoginDataAction,
    UpdateAccountAction,
    UpdateTokenAction,
} from 'actions/authActions';

import { ReduxAction } from 'actions';
import { getPermissionsByToken } from '@root/utils/Auth';
import { UserAllDataFragment, adminLogin_adminLogin } from '@api/graphql/types';

export interface AuthReducer {
    user: UserAllDataFragment | null;
    token: string | null;
    permissions: string[] | null;
}

const initialState: AuthReducer = {
    user: null,
    token: null,
    permissions: null,
};

export default function (state: AuthReducer = initialState, action: ReduxAction) {
    let permissions = state.permissions;
    switch (action.type) {
        case AuthActionType.changeLoginData:
            const changeLoginDataAction = (action as ChangeLoginDataAction);
            if (changeLoginDataAction.adminLoginData) {
                if ((changeLoginDataAction.adminLoginData as adminLogin_adminLogin).token) {
                    permissions = getPermissionsByToken((changeLoginDataAction.adminLoginData as adminLogin_adminLogin).token);
                }
                const changedState = { ...state, ...changeLoginDataAction.adminLoginData, permissions };
                return changedState;
            }
            return initialState;
        case AuthActionType.updateToken:
            permissions = getPermissionsByToken((action as UpdateTokenAction).token);
            return { ...state, token: (action as UpdateTokenAction).token, permissions };
        case AuthActionType.updateAccount:
            return { ...state, user: (action as UpdateAccountAction).user };
        case AuthActionType.logout:
            return initialState;
        default:
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/authReducer.ts